import React from 'react'

import PositionsListHeader from './PositionsListHeader/PositionsListHeader'
import PositionsListItem from './PositionsListItem/PositionsListItem'
import StateInfoItem from './StateInfoItem/StateInfoItem'

import positionsListContainer from './positionsListContainer'
import './PositionsList.css'

export const PositionsList = ({ positions }) => {
  const listItems = positions.map((position, i) =>
    <PositionsListItem key={i} position={position} />
  )

  return (
    <div className="col-md-4 PositionsList">
      <PositionsListHeader count={positions.length} />
      <div className="list-group PositionsList__list">
        <StateInfoItem />
        {listItems}
      </div>
    </div>
  )
}

export default positionsListContainer(PositionsList)



// WEBPACK FOOTER //
// ./src/components/PositionsScene/PositionsList/PositionsList.js